import { IAppActionSetClinicalLibraryLoading, IUnifiedState } from "./interface";

/**
 * Sets the clinical library loading flag.
 *
 * @param state - The current unified application state.
 * @param action - The set-clinical-library-loading action to apply.
 * @returns Unified state with the current deferred request status.
 */
export const app_setClinicalLibraryLoading = (
  state: IUnifiedState,
  action: IAppActionSetClinicalLibraryLoading,
): IUnifiedState => ({
  ...state,
  isClinicalLibraryLoading: action.isClinicalLibraryLoading,
});
